import { PILLARS } from "@/data/content";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function WhyUs() {
  return (
    <section
      id="about"
      data-testid="why-us-section"
      className="relative bg-ink py-24 lg:py-36 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Overline className="mb-7">Why MOTO LUXE</Overline>
          </Reveal>
          <Reveal delay={0.06}>
            <h2 className="font-serif text-4xl sm:text-6xl lg:text-7xl text-cream uppercase tracking-tight leading-[0.95]">
              Details Make
              <br />
              The <span className="gold-text italic lowercase">difference.</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5 border border-white/5">
          {PILLARS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.07}>
              <div className="group bg-ink hover:bg-charcoal transition-colors duration-500 p-8 lg:p-12 h-full">
                <div className="flex items-baseline gap-5">
                  <span className="font-serif text-5xl lg:text-6xl text-gold/25 group-hover:text-gold/60 transition-colors duration-500">
                    {p.n}
                  </span>
                  <h3 className="font-serif text-2xl lg:text-3xl text-cream">
                    {p.title}
                  </h3>
                </div>
                <p className="mt-5 text-cream/55 font-light leading-relaxed max-w-md">
                  {p.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
